import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/tr';
import 'moment/locale/uk';

import { Lang } from '../../typings/common';

export class LangUtils {
    static getCurrentLang(): Lang {
        return Lang[process.env.BEM_LANG || 'ru'];
    }

    static init(): void {
        const lang = this.getCurrentLang();

        moment.locale(lang);
    }
}
